import * as React from "react";
import { unicon } from "../../../common";

export default unicon(<path d="M19 11h-6V5a1 1 0 00-2 0v6H5a1 1 0 000 2h6v6a1 1 0 002 0v-6h6a1 1 0 000-2z" />);
